"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultAuthorisedPersonDisplaySettings = void 0;
var _radios = require("../../constants/radios");
var defaultAuthorisedPersonDisplaySettings = exports.defaultAuthorisedPersonDisplaySettings = {
  readonlyMode: false,
  authorisedPersonPanelToggleRadios: {
    name: 'owner.hasAuthorisePerson',
    groupLabel: 'Do you want to add an authorised person?',
    groupLabelTooltip: 'An authorised person is permitted to transact on policies in a limited capacity such as submitting claims and making general enquiries on behalf of the policyholder. We are only able to amend cover and ownership details directly with the policyholder. This is necessary to protect the interests of the policyholder in their contract with us. Key changes or updates must be made with direct knowledge and authorisation of the policyholder.',
    radioInputs: _radios.SIMPLE_YES_NO,
    validation: {
      required: 'Please choose an option'
    }
  },
  authorisedPersonFirstNameInput: {
    name: 'owner.authorisedMemberFirstName',
    label: 'First name',
    placeholder: 'Enter first name',
    validation: {
      required: 'Please enter your authorised person\'s first name.'
    }
  },
  authorisedPersonLastNameInput: {
    name: 'owner.authorisedMemberSurname',
    label: 'Last name',
    placeholder: 'Enter last name',
    validation: {
      required: 'Please enter your authorised person\'s last name.'
    }
  },
  authorisedPersonBirthdateInput: {
    name: 'owner.authorisedMemberDob',
    label: 'Date of birth',
    labelTooltip: 'Your authorised person must be over 18 years of age.',
    placeholder: 'dd/mm/yyyy',
    validation: {
      required: 'Please enter your authorised person\'s date of birth.'
    }
  }
};